import { render, staticRenderFns } from "./SendVideo.vue?vue&type=template&id=22bc7f96&scoped=true&"
import script from "./SendVideo.vue?vue&type=script&lang=js&"
export * from "./SendVideo.vue?vue&type=script&lang=js&"
import style0 from "./SendVideo.vue?vue&type=style&index=0&id=22bc7f96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc7f96",
  null
  
)

export default component.exports